.modal {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  padding: 2rem 1rem;
  overflow-x: hidden;
  overflow-y: auto;
}

.paper {
  position: relative;
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  max-width: 800px;
  max-height: calc(100vh - 4rem);
  max-height: calc(100dvh - 4rem);
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14), 0 1px 14px 0 rgba(0, 0, 0, 0.12);
  padding: 1.5rem 2rem 2rem;
  overscroll-behavior: contain;
}

.formTitle {
  padding-right: 2rem;
}

.tabs {
  min-width: 0;
  width: 100%;
  max-width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.tabs :global(.MuiTabs-scroller) {
  min-width: 0;
}
.tabs :global(.MuiTab-root) {
  min-width: auto;
  padding-right: 1rem;
  padding-left: 1rem;
  white-space: nowrap;
}

.tabPanel {
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  padding-top: 1.5rem;
}

.formFields {
  min-width: 0;
  width: 100%;
  gap: 1rem;
}

.field {
  min-width: 0;
  width: 100%;
  max-width: 100%;
}

.buttons {
  margin-top: 1rem;
  gap: 1rem;
}

.button {
  min-width: 0;
  flex: 1 1 0;
}

.closeIcon {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5rem;
  font-size: 3rem !important;
  color: #888;
  cursor: pointer;
}

.imgComponent {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 180px;
  margin: 0.75rem auto;
  object-fit: contain;
}

.assetSection {
  min-width: 0;
  width: 100%;
}

.sectionTitle {
  font-size: 1.1rem !important;
}

.divider {
  width: 100%;
  margin: 0.25rem 0;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

@media (max-width: 600px) {
  .modal {
    padding: 0.75rem;
  }
  .paper {
    max-height: calc(100vh - 1.5rem);
    max-height: calc(100dvh - 1.5rem);
    padding: 1.25rem 1rem;
  }
  .buttons {
    flex-direction: column;
  }
  .button {
    width: 100%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */